var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuiasPendientes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 55,
    viewBox: "0 0 60 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8551 50.4141C32.5593 50.4141 34.7718 48.3516 34.7718 45.8307H24.9385C24.9385 48.3516 27.151 50.4141 29.8551 50.4141ZM44.6051 36.6641V25.2057C44.6051 18.1703 40.5981 12.2807 33.5426 10.7224V9.16406C33.5426 7.26198 31.8956 5.72656 29.8551 5.72656C27.8147 5.72656 26.1676 7.26198 26.1676 9.16406V10.7224C19.1368 12.2807 15.1051 18.1474 15.1051 25.2057V36.6641L10.1885 41.2474V43.5391H49.5218V41.2474L44.6051 36.6641ZM39.6885 38.9557H20.0218V25.2057C20.0218 19.5224 23.7339 14.8932 29.8551 14.8932C35.9764 14.8932 39.6885 19.5224 39.6885 25.2057V38.9557Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuiasPendientes);
export default __webpack_public_path__ + "static/media/guiasPendientes.1bcf9efe75fb806a633aa8e675d2f104.svg";
export { ForwardRef as ReactComponent };